export const primaryColor = '#1e355e';
export const secondaryColor = '#4aa74a';
export const scrollbarColor = '#666666';
export const scrollbarHoverColor = '#858585';
export const scrollbarBgColor = '#f0f0f0';
export const textColor = '#666666';
export const errorColor = '#d30e0e';
